export default __webpack_public_path__ + "6ec9d263fb46252dd146d64ffbc28d69.webp";